<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuth } from "./useAuth";

const router = useRouter();
const { login } = useAuth(); // Достаем функцию логина из нашего глобального хранилища

const handleRegister = async () => {
  // Перенаправление пользователя на страницу регистрации
  router.push("/registration");
};

// Реактивная переменная для отслеживания видимости пароля
const showPassword = ref(false);

// Реактивные переменные для данных формы
const email = ref("");
const password = ref("");

// Вычисляемое свойство для валидации формы (реактивно следит за email и password)
const isFormValid = computed(() => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email.value) && password.value.length >= 6;
});

const handleLoginSubmit = async () => {
  // Формируем объект с данными для отправки на бэкенд
  const loginData = {
    email: email.value,
    password: password.value,
  };

  console.log("Данные для бэкенда (Логин):", loginData);

  // Отправляем данные на твой Node.js бэкенд
  try {
    const response = await fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(loginData),
    });
    const data = await response.json();

    if (response.ok) {
      // Успешный вход! Используем глобальную функцию логина
      // Она сама положит токен в localStorage и обновит состояние для шапки
      login(data.token);
      router.push("/profile");
    } else {
      alert("Ошибка входа: " + data.error);
    }
  } catch (error) {
    console.error("Ошибка сети:", error);
  }
};
</script>

<template>
  <!-- prettier-ignore  -->
  <div class="flex items-center justify-center min-h-svh w-full bg-whitebglog
  p-4 sm:p-8">
    <div class="flex w-full max-w-[1685px]
    mx-full h-full py-26 items-center justify-center">
      <div class="bg-white max-w-[480px] w-full rounded-3xl items-center justify-center p-6 sm:p-10">
        <!-- Привязываем отправку формы к нашей новой функции -->
        <form class="flex flex-col gap-5 w-full max-w-sm" @submit.prevent="handleLoginSubmit">
          
          <div class="flex justify-center">
            <img src="../../public/svg/HandBox_icon.svg" class="w-[64px] h-[64px]" alt="Icon" >
          </div>

          <h2 class="text-3xl font-bold text-center mb-4 text-black">Вход</h2>
          
          <input 
            type="email" 
            v-model="email"
            placeholder="Электронная почта" 
            class="text-black bg-white p-4 rounded-xl border border-gray-300 w-full 
            focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all" 
            required 
          />
          
          <div class="relative w-full">
    
            <input 
              :type="showPassword ? 'text' : 'password'" 
              v-model="password"
              placeholder="Пароль" 
              class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
              focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all"
              required
            >
    
            <button 
              type="button" 
              @click="showPassword = !showPassword"
              class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center 
              mr-4 text-gray-400 hover:text-gray-600 focus:outline-none"
            >
              <span class="text-lg leading-none cursor-pointer">{{ showPassword ? '👁️' : '👁️‍🗨️' }}</span>
            </button>
          </div>
          
          <p class="text-left cursor-pointer mb-2">
            Не помню пароль
          </p>
          
          <button 
            type="submit" 
            :disabled="!isFormValid"
            :class="[
              'font-normal p-4 rounded-xl w-full transition-colors mt-2',
              isFormValid 
                ? 'bg-black text-white hover:bg-gray-800 cursor-pointer' 
                : 'bg-[#D9D9D9] text-[#888888] cursor-not-allowed'
            ]"
          >
            Войти
          </button>

          <button
            type="button"
            class="bg-transparent text-black border border-gray-300
            font-normal p-4 rounded-xl w-full hover:bg-black 
            hover:text-white
            transition-colors cursor-pointer"
            @click="handleRegister"
          >
          Создать профиль
        </button>
        </form>
      </div>
    </div>
  </div>
</template>
